<template>
  <v-container grid-list-xs fluid>
    <!-- DATA TABLE -->
    <v-card class="layout row wrap shadow pa-3 mt-3">
      <div class="flex-row justify-space-between align-center grey lighten-4">
        <v-menu offset-y>
          <strong class="title_label pl-2" slot="activator">
            <span>{{ filter.title }}</span>
          </strong>
          <v-list>
            <v-list-tile
              :key="index"
              @click="filter = item"
              v-for="(item, index) in filters"
            >
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-spacer />
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              flat
              v-on="on"
              color="grey darken-2"
              class="ma-0 mr-2 pa-0"
              @click="printTable(false)"
            >
              <v-icon>print</v-icon>
            </v-btn>
          </template>
          <span>Print Table</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              flat
              v-on="on"
              color="grey darken-2"
              class="ma-0 mr-2 pa-0"
              @click="printTable(true)"
            >
              <v-icon>file_download</v-icon>
            </v-btn>
          </template>
          <span>Excel Export</span>
        </v-tooltip>
      </div>

      <v-data-table
        ref="tbl"
        class="flex xs12"
        :headers="headers"
        :loading="loading"
        :items="filteredItems"
        :rows-per-page-items="per_page"
      >
        <template v-slot:items="{ item }">
          <tr>
            <td class="font-weight-bold">
              <router-link :to="`/CSOs/${item.id}`">
                {{ item.name }}
              </router-link>
            </td>
            <td class="font-weight-bold">{{ item.p1_st | pretty }}</td>
            <td class="font-weight-bold">{{ item.p2_st | pretty }}</td>
            <td class="font-weight-bold">{{ item.p3_st | pretty }}</td>
            <td class="font-weight-bold">{{ item.p4_st | pretty }}</td>
            <td class="font-weight-bold">{{ item.p5_st | pretty }}</td>
            <td :class="item.total_st">{{ item.total_st }}</td>
          </tr>
        </template>
        <template slot="footer">
          <tr class="font-weight-bold" v-for="item in summery" :key="item.name">
            <td :class="item.name">{{ item.name }}</td>
            <td>{{ item.p1_st }}</td>
            <td>{{ item.p2_st }}</td>
            <td>{{ item.p3_st }}</td>
            <td>{{ item.p4_st }}</td>
            <td>{{ item.p5_st }}</td>
            <td>{{ item.total_st }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
let currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 7);

export default {
  name: "reports-view",
  data: () => ({
    items: [],
    loading: false,
    programAreas: [],
    filters: [
      {
        title: "All CSOs - Status Analysis",
        value: false,
        filterFunc: () => true
      },
      {
        value: "Pending",
        title: "Pending CSOs  - Status Analysis",
        filterFunc: item => item.total_st == "Pending"
      },
      {
        value: "Certified",
        title: "Certified CSOs  - Status Analysis",
        filterFunc: item => item.total_st == "Certified"
      },
      {
        value: "Deferred",
        title: "Deferred CSOs  - Status Analysis",
        filterFunc: item => item.total_st == "Deferred"
      }
    ],
    filter: {
      title: "All CSOs - Status Analysis",
      value: false,
      filterFunc: () => true
    }
  }),
  filters: {
    pretty: val => (val == 1 ? "Q" : "NQ")
  },
  computed: {
    filteredItems() {
      return this.items.filter(x => this.filter.filterFunc(x));
    },
    headers: vm => [
      { text: "CSOs Name", value: "name" },
      { text: `${vm.$t("part1")}`, value: "p1_st", width: "100px" },
      { text: vm.$t("part2"), value: "p2_st", width: "100px" },
      { text: vm.$t("part3"), value: "p3_st", width: "100px" },
      { text: vm.$t("part4"), value: "p4_st", width: "100px" },
      { text: vm.$t("part5"), value: "p5_st", width: "100px" },
      { text: vm.$t("status"), value: "total_st", width: "100px" }
    ],
    summery() {
      let p1_st = 0,
        p2_st = 0,
        p3_st = 0,
        p4_st = 0,
        p5_st = 0,
        total_st = 0,
        length = this.filteredItems.length;
      this.filteredItems.forEach(item => {
        p1_st += Number(item.p1_st);
        p2_st += Number(item.p2_st);
        p3_st += Number(item.p3_st);
        p4_st += Number(item.p4_st);
        p5_st += Number(item.p5_st);
        total_st += item.total_st == "Certified";
      });
      return [
        // {
        //   name: "Qualified",
        //   class: "font-weight-bold",
        //   p1_st: `${(p1_st * 100) / length} %`,
        //   p2_st: `${(p2_st * 100) / length} %`,
        //   p3_st: `${(p3_st * 100) / length} %`,
        //   p4_st: `${(p4_st * 100) / length} %`,
        //   p5_st: `${(p5_st * 100) / length} %`,
        //   total_st: `${(total_st * 100) / length} %`
        // },
        // {
        //   name: "Not-Qualified",
        //   class: "font-weight-bold",
        //   p1_st: `${((length - p1_st) * 100) / length} %`,
        //   p2_st: `${((length - p2_st) * 100) / length} %`,
        //   p3_st: `${((length - p3_st) * 100) / length} %`,
        //   p4_st: `${((length - p4_st) * 100) / length} %`,
        //   p5_st: `${((length - p5_st) * 100) / length} %`,
        //   total_st: `${((length - total_st) * 100) / length} %`
        // },
        {
          name: "Qualified",
          class: "font-weight-bold",
          p1_st: `${p1_st}`,
          p2_st: `${p2_st}`,
          p3_st: `${p3_st}`,
          p4_st: `${p4_st}`,
          p5_st: `${p5_st}`,
          total_st: `${total_st}`
        },
        {
          name: "Not-Qualified",
          class: "font-weight-bold",
          p1_st: `${length - p1_st}`,
          p2_st: `${length - p2_st}`,
          p3_st: `${length - p3_st}`,
          p4_st: `${length - p4_st}`,
          p5_st: `${length - p5_st}`,
          total_st: `${length - total_st}`
        },
        {
          name: "Total",
          class: "font-weight-bold",
          total_st: `${length}`
        }
      ];
    }
  },

  methods: {
    getData() {
      this.loading = true;
      this.axios
        .get(`reports?analytical=true`)
        .then(res => {
          this.items = res.data;
          this.loading = false;
        })
        .catch(vm => (vm.loading = false));
    },

    printTable(excel) {
      let items = [...this.filteredItems, ...this.summery];
      let data = {
        items: items,
        headers: this.headers,
        title: this.$t("analytical_status")
      };

      if (excel) return this.xl_tables(data, "Analytical - Status Report");
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    }
  },
  created() {
    this.getData();
  }
};
</script>
